import { render, staticRenderFns } from "./StrukA4.vue?vue&type=template&id=e766cf46&scoped=true&"
import script from "./StrukA4.vue?vue&type=script&lang=js&"
export * from "./StrukA4.vue?vue&type=script&lang=js&"
import style0 from "./StrukA4.vue?vue&type=style&index=0&id=e766cf46&lang=scss&scoped=true&"
import style1 from "./StrukA4.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e766cf46",
  null
  
)

export default component.exports